import { z } from 'zod';
/**
 * STELLAJ GEOMETRIYASI.
 *
 * Manba — fizik temir: ikkita balka orasidagi bo'shliq bitta "qator"
 * (`levelHeights`), qator ichidagi ajratgichlar orasidagi joy bitta
 * "proyom" (`bays`). Shuning uchun o'lchamlar RO'YXAT bo'lib saqlanadi,
 * bitta "eni" va "qator balandligi" emas.
 *
 * PROYOMLAR HAR QATORDA O'ZINIKI. `bays` — ikki qavatli ro'yxat: har
 * qator uchun alohida bo'linish, pastdan tepaga.
 *
 *   bays = [
 *     [0.3, 0.4, 1.3],   ← 1-qator uchga bo'lingan
 *     [2.0],             ← 2-qator butun
 *     [1.0, 1.0],        ← 3-qator ikkiga
 *   ]
 *
 * NEGA SHUNDAY. Ilgari `bays` bitta ro'yxat edi va bo'linish MAJBURAN
 * hamma qatorga tushardi — katak to'ri to'g'ri to'rtburchak bo'lishi
 * kerak edi. Ombor amaliyoti boshqacha: ajratgich javonning kerakli
 * taxtasiga qo'yiladi, qolgan qatorlar tegilmaydi. Omborchi "shu
 * o'ringa 30 sm ga bitta mahsulot kiradi" deganda aynan bitta qator
 * haqida gapiradi.
 *
 * HAR QATORNING YIG'INDISI BIR XIL: stellajning uzunligi bitta va
 * ajratgich uni faqat bo'ladi, uzaytirmaydi. Bu qoida sxemada
 * tekshiriladi.
 *
 * Umumiy uzunlik va balandlik SAQLANMAYDI — ular yig'indi. Ikkalasini ham
 * saqlash ikki manba yaratardi va ular bir kun kelib bir-biriga zid bo'lardi.
 */
/**
 * STELLAJ TURI — temirli javonmi yoki OCHIQ MAYDONMI.
 *
 * `FLOOR` — maydon: rama ham, balka ham yo'q, o'rinlar YERGA belgilangan.
 * Rels, shpal, tirma, g'ildirak juftligi kabi yirik mol javonga umuman
 * sig'maydi — u polda, bo'yoq bilan chizilgan o'rinda turadi.
 *
 * NEGA ALOHIDA TUR, alohida jadval emas. Maydon ham, stellaj ham
 * KATAKLARNING manbai, katakda esa etiketka, sig'im, ajratish va qoldiq
 * bor. Ikkinchi jadval bularning hammasini ikki nusxada qilishni talab
 * qilardi — ikkita kirim yo'li, ikkita skaner yo'li, ikkita hisobot.
 * Fizik farq esa bittagina: maydon — BIR QAVATLI stellaj, ramasi yo'q.
 */
export const RACK_KINDS = ['RACK', 'FLOOR'];
export const rackKindSchema = z.enum(RACK_KINDS);
/**
 * Ochiq maydon BIR QAVATLI bo'ladi.
 *
 * Qavat — balkalar orasidagi bo'shliq, ya'ni temirning o'zi. Maydonda
 * temir yo'q: molni ustma-ust taxlash mumkin, lekin bu ikkinchi qavat
 * emas va unga alohida etiketka yopishtirib bo'lmaydi.
 *
 * Saqlanadigan yagona balandlik — TAXLASH CHEGARASI (`levelHeights[0]`):
 * "bu maydonga 2 metrdan baland taxlanmaydi".
 */
export const checkFloorRack = (rack, ctx) => {
    if (rack.kind !== 'FLOOR')
        return;
    if (rack.levelHeights === undefined || rack.levelHeights.length === 1)
        return;
    ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['levelHeights'],
        message: 'Ochiq maydon bir qavatli bo\'ladi',
    });
};
/**
 * STELLAJ proyomining eng katta kengligi, m.
 *
 * Chegara temirdan keladi: proyomni balka tutib turadi va eng uzun
 * standart balka 3.6 m. 6 m — zaxirasi bilan olingan chegara.
 */
export const MAX_RACK_BAY_WIDTH_M = 6;
/**
 * OCHIQ MAYDON o'rnining eng katta kengligi, m.
 *
 * Maydonda balka YO'Q — o'rin polga bo'yoq bilan chiziladi va uning
 * uzunligini faqat omborning o'zi cheklaydi. «Boks 1» kabi 12 metrli
 * maydon odatiy hol edi, lekin stellajning balka chegarasi unga ham
 * tushib, saqlashga yo'l bermasdi.
 *
 * `depthM` bilan bir xil chegara: ikkalasi ham omborning o'lchami.
 */
export const MAX_FLOOR_BAY_WIDTH_M = 50;
/* Sxema eng KENGINI qabul qiladi, stellajning tor chegarasi esa turi
   ma'lum bo'lgan joyda qo'yiladi (`checkRackBayWidths`): `bays` ning
   o'zi turni bilmaydi va PATCH da tur umuman kelmaydi. */
const bayWidthSchema = z.number().positive().max(MAX_FLOOR_BAY_WIDTH_M);
/**
 * Proyom kengligi TURGA mos keladimi.
 *
 * Alohida tekshiruv, chunki chegara `bays` ning o'zidan emas, stellaj
 * TURIDAN keladi va zod elementni tekshirayotganda turni ko'rmaydi.
 * PATCH da tur umuman yuborilmaydi (u o'zgarmaydi), shuning uchun
 * tahrirda bu qoidani xizmat qatlami qo'yadi — u yerda javonning
 * saqlangan turi bor.
 */
export const checkRackBayWidths = (rack, ctx) => {
    if (rack.kind === 'FLOOR' || rack.bays === undefined)
        return;
    rack.bays.forEach((row, level) => {
        row.forEach((width, index) => {
            if (width <= MAX_RACK_BAY_WIDTH_M)
                return;
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['bays', level, index],
                message: `Stellaj proyomi ${String(MAX_RACK_BAY_WIDTH_M)} m dan keng bo'lmaydi — buncha balka yo'q`,
            });
        });
    });
};
/** Bitta qator balandligi, m. */
const levelHeightSchema = z.number().positive().max(10);
/** Bitta qatorning bo'linishi — chapdan o'ngga. */
export const levelBaysSchema = z.array(bayWidthSchema).min(1).max(99);
/** Yig'indilarni solishtirishdagi bo'shashish, m — millimetrning yarmi. */
const SUM_TOLERANCE_M = 0.0005;
/**
 * Xom shakl — `superRefine` siz.
 *
 * `superRefine` `ZodEffects` qaytaradi va unda `.shape` bo'lmaydi, ya'ni
 * `createRackSchema` uni kengaytira olmasdi. Shuning uchun asos alohida
 * turadi va tekshiruv ustiga qo'shiladi.
 */
export const rackGeometryBase = z.object({
    pos: z.object({
        x: z.number().finite(),
        y: z.number().finite(),
        rotationDeg: z.number().min(0).max(359),
    }),
    /** Ichki kenglik — ramaning chuqurligi. Proyomga bog'liq emas. */
    depthM: z.number().positive().max(50),
    /**
     * HAR QATORNING proyomlari, pastdan tepaga; ichkarida chapdan o'ngga.
     * Uzunligi `levelHeights` bilan bir xil bo'lishi shart.
     */
    bays: z.array(levelBaysSchema).min(1).max(99),
    /** Qatorlar balandligi, pastdan tepaga. Uzunligi = qatorlar soni. */
    levelHeights: z.array(levelHeightSchema).min(1).max(99),
});
/**
 * `bays` va `levelHeights` bir-biriga mos ekanini tekshiradi.
 *
 * Alohida funksiya, chunki bu qoida `createRackSchema` da ham,
 * `updateRackSchema` da ham kerak — ikkinchisida maydonlar ixtiyoriy va
 * sxemani takrorlash qoidani ikki nusxada qoldirardi.
 */
export const checkRackRows = (rack, ctx) => {
    const { bays, levelHeights } = rack;
    if (bays === undefined)
        return;
    if (levelHeights !== undefined && bays.length !== levelHeights.length) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['bays'],
            message: 'Har qator uchun proyomlar ro\'yxati bo\'lishi kerak',
        });
        return;
    }
    /* Stellajning uzunligi BITTA: ajratgich uni bo'ladi, uzaytirmaydi.
       Bu tekshiruvsiz qatorlari bir-biridan chiqib ketgan javon
       saqlanardi va u faqat chizmada, egri ko'rinish bo'lib bilinardi. */
    const first = sum(bays[0] ?? []);
    for (const [index, row] of bays.entries()) {
        if (Math.abs(sum(row) - first) > SUM_TOLERANCE_M) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['bays', index],
                message: 'Qatorlar yig\'indisi bir xil bo\'lishi kerak',
            });
        }
    }
};
export const rackGeometrySchema = rackGeometryBase.superRefine(checkRackRows);
const sum = (values) => values.reduce((total, v) => total + v, 0);
/** Qatorlar soni. */
export const rackLevels = (rack) => rack.levelHeights.length;
/**
 * BERILGAN qatordagi kataklar soni.
 *
 * Qator raqami 1 dan boshlanadi. Mavjud bo'lmagan qatorda 0 qaytadi —
 * bu chizuvchilar uchun muhim: eskirgan javobdagi katak sahnani
 * yiqitmasligi kerak.
 */
export const rackCellsPerLevel = (rack, level) => rack.bays[level - 1]?.length ?? 0;
/**
 * Stellajning umumiy uzunligi.
 *
 * BIRINCHI qator bo'yicha o'lchanadi va bu yetarli: sxema hamma
 * qatorning yig'indisi bir xil ekanini tekshiradi.
 */
export const rackWidthM = (rack) => sum(rack.bays[0] ?? []);
/** Stellajning umumiy balandligi — qatorlar yig'indisi. */
export const rackHeightM = (rack) => sum(rack.levelHeights);
/** Jami kataklar — qatorlar har xil bo'lingani uchun yig'indi. */
export const rackCellCount = (rack) => rack.bays.reduce((total, row) => total + row.length, 0);
/**
 * KATAKNING QATORDAGI O'RNI — kodidagi raqam EMAS, chapdan sanalgan tartibi.
 *
 * Yaratilgan javonda ikkisi bir xil: 1-katak birinchi proyomda turadi.
 * Lekin ikkita katak BIRLASHTIRILGANDA ular ajraladi va bu ataylab.
 *
 * Misol: 2-qatorda to'rtta o'rin bor edi, chapdagi ikkitasi qo'shildi.
 *
 *   ilgari:  02-01 │ 02-02 │ 02-03 │ 02-04
 *   keyin:   02-01    keng  │ 02-03 │ 02-04
 *
 * «Головной убор» qanday 02-03 da turgan bo'lsa, shunday turibdi —
 * javonda u JOYIDAN QIMIRLAMAGAN, chunki olib tashlangan ajratgich
 * undan chapda edi. Shuning uchun uning kodi ham, etiketkasi ham
 * o'zgarmaydi: aks holda ombor bo'ylab yurib, hech nima ko'chmagan
 * bo'lsa ham, yarim javonning yorlig'ini qayta yopishtirish kerak
 * bo'lardi.
 *
 * Narxi shu: `bays` ro'yxatidagi o'rin endi `idx - 1` emas. Qatordagi
 * kataklar `idx` bo'yicha tartiblanadi va O'SHA tartib proyomga mos
 * keladi — 02-03 uchinchi emas, IKKINCHI proyomda.
 */
export const cellRank = (levelCells, idx) => [...levelCells].sort((a, b) => a.idx - b.idx).findIndex((cell) => cell.idx === idx) + 1;
/** Qatordagi kataklar chapdan o'ngga — o'rni ro'yxatdagi tartibi. */
export const byRank = (levelCells) => [...levelCells].sort((a, b) => a.idx - b.idx);
/**
 * Katakning ombor koordinatalar tizimidagi markazi va o'lchami.
 * X-Y — pol tekisligi, Z — balandlik. Stellaj markazi `pos` da turadi.
 *
 * Uchinchi argument — O'RIN (`cellRank`), katak kodidagi raqam emas.
 * Birlashtirilgan qatorda ikkisi bir-biridan farq qiladi.
 */
export const cellTransform = (rack, level, rank) => {
    const levels = rackLevels(rack);
    if (!Number.isInteger(level) || level < 1 || level > levels) {
        throw new Error(`Qator ${level} stellajda mavjud emas (jami ${levels})`);
    }
    // Proyomlar SHU qatorniki: qo'shni qatorlar boshqacha bo'lingan bo'lishi mumkin.
    const row = rack.bays[level - 1];
    const perLevel = row.length;
    if (!Number.isInteger(rank) || rank < 1 || rank > perLevel) {
        throw new Error(`O'rin ${rank} ${level}-qatorda mavjud emas (jami ${perLevel})`);
    }
    const width = rackWidthM(rack);
    const bayWidth = row[rank - 1];
    const levelHeight = rack.levelHeights[level - 1];
    // Chapki chetdan sanaladi: oldingi proyomlar yig'indisi + shu proyom yarmi.
    const offsetAlong = -width / 2 + sum(row.slice(0, rank - 1)) + bayWidth / 2;
    const rad = (rack.pos.rotationDeg * Math.PI) / 180;
    return {
        center: {
            x: rack.pos.x + offsetAlong * Math.cos(rad),
            y: rack.pos.y + offsetAlong * Math.sin(rad),
            z: sum(rack.levelHeights.slice(0, level - 1)) + levelHeight / 2,
        },
        size: { w: bayWidth, d: rack.depthM, h: levelHeight },
        rotationDeg: rack.pos.rotationDeg,
    };
};
/**
 * Umumiy uzunlikni teng proyomlarga bo'ladi.
 *
 * Usta "umumiy uzunlik + nechta proyom" so'raydi, keyin har birini alohida
 * tahrirlashga ruxsat beradi. Qoldiq OXIRGI proyomga qo'shiladi: aks holda
 * yig'indi umumiy uzunlikka teng bo'lmay qolardi va chizma bir necha
 * millimetrga "qisqarardi".
 */
export const splitEvenly = (totalM, parts, 
/**
 * Yaxlitlash qadami, m. Standart — millimetr (saqlash aniqligi). Ekran
 * SANTIMETRDA ishlaydi va `0.01` uzatadi: aks holda 2 m ni uchga
 * bo'lganda maydonlarda 67 + 67 + 67 ko'rinib, ular 200 ga yig'ilmay
 * qolardi.
 */
stepM = 0.001) => {
    if (!Number.isInteger(parts) || parts < 1)
        throw new Error('Qismlar soni 1 dan kichik bo\'lmaydi');
    if (!(totalM > 0))
        throw new Error('Umumiy o\'lcham musbat bo\'lishi kerak');
    const snap = (value) => Math.round(value / stepM) * stepM;
    const each = snap(totalM / parts);
    const list = Array.from({ length: parts }, () => each);
    list[parts - 1] = snap(totalM - each * (parts - 1));
    return list;
};
/**
 * Qismlarni NISBATINI saqlagan holda yangi umumiy o'lchamga moslaydi.
 *
 * Rejada stellajni sichqoncha bilan cho'zganda ishlatiladi: proyomlar soni
 * o'zgarmaydi (ya'ni katak kodlari ham, etiketkalar ham tegilmaydi), faqat
 * kengliklari birga o'zgaradi. Teng bo'lmagan bo'linish shu bilan saqlanadi.
 */
export const rescaleParts = (parts, totalM, 
/**
 * Yaxlitlash qadami, m. Standart — millimetr (saqlash aniqligi). Ekran
 * SANTIMETRDA ishlaydi va `0.01` uzatadi: aks holda 8.00 m ni uchga
 * bo'lganda maydonlarda 267 + 267 + 267 ko'rinib, ular 800 ga
 * yig'ilmay qolardi.
 */
stepM = 0.001) => {
    if (parts.length === 0)
        throw new Error('Qismlar ro\'yxati bo\'sh');
    if (!(totalM > 0))
        throw new Error('Umumiy o\'lcham musbat bo\'lishi kerak');
    const snap = (value) => Math.round(value / stepM) * stepM;
    const current = sum(parts);
    const factor = totalM / current;
    const scaled = parts.map((part) => snap(part * factor));
    // Qoldiq oxirgi qismga — yig'indi so'ralgan o'lchamga aniq teng qolsin.
    scaled[scaled.length - 1] = snap(totalM - sum(scaled.slice(0, -1)));
    return scaled;
};
/**
 * Kasr xatosiga qarshi bo'shashish, m.
 *
 * 7.2 / 1.8 suzuvchi nuqtada 4.000000000000001 bo'lib chiqishi mumkin va
 * `ceil` undan BESHTA qator yasab yuborardi. Yarim millimetr — saqlash
 * aniqligidan ham mayda, ya'ni haqiqiy o'lchamga tegmaydi.
 */
const CEIL_EPSILON = 0.0005;
/**
 * Balandlikni YARUS BALANDLIGIGA qarab qatorlarga bo'ladi.
 *
 * NEGA KERAK. `rescaleParts` qismlar SONINI saqlaydi va bu rejada javonni
 * sichqoncha bilan cho'zish uchun to'g'ri: katak kodlari o'zgarmaydi, ya'ni
 * bosilgan etiketkalar kuchda qoladi. Lekin javonni NOLDAN yasashda bu
 * mantiq teskari natija beradi: standart 4 qator qolib, 2 metrli javon
 * 4 × 50 sm ga bo'linadi.
 *
 * Javonni yasashda operator o'ylaydigan narsa boshqacha: "javon 2 metr,
 * yarus 50 sm" — ya'ni SON balandlikdan kelib chiqadi, aksincha emas.
 *
 * YARUS BALANDLIGI — CHEGARA, maqsad emas. Shuning uchun `Math.ceil`,
 * `round` emas. Ilgari `round` edi va 200 sm li javon 180 sm li yarusga
 * bo'linganda 200 / 180 = 1,11 → BITTA 200 sm li yarus chiqardi: odam
 * 180 so'ragan bo'lsa ham 20 sm balandroq bo'shliq. Bunday javon
 * yaruslarsiz quruq to'rtburchakka aylanardi. Balka ramaning teshigiga
 * qo'yiladi, ya'ni so'ralganidan BALAND oraliq fizik jihatdan chiqmaydi —
 * qator qo'shiladi va hammasi pasayadi: 200 / 180 → ikkita 100 sm.
 *
 * Teskari tomonda chegara yo'q: javonning o'zi yarusdan past bo'lsa
 * (2 m javon, 2.7 m yarus) bitta past qator qoladi — uni cho'zib
 * bo'lmaydi.
 */
export const splitIntoSlots = (totalM, slotM, 
/** Yaxlitlash qadami, m. Ekran santimetrda ishlaydi va `0.01` uzatadi. */
stepM = 0.001) => {
    if (!(totalM > 0))
        throw new Error('Umumiy o\'lcham musbat bo\'lishi kerak');
    if (!(slotM > 0))
        throw new Error('O\'rin kengligi musbat bo\'lishi kerak');
    const count = Math.max(1, Math.ceil(totalM / slotM - CEIL_EPSILON));
    const snap = (value) => Math.round(value / stepM) * stepM;
    const each = snap(totalM / count);
    const list = Array.from({ length: count }, () => each);
    // Qoldiq oxirgi o'ringa: yig'indi so'ralgan uzunlikka ANIQ teng qolsin,
    // aks holda maydonlardagi sonlar umumiy o'lchamga yig'ilmaydi.
    list[count - 1] = snap(totalM - each * (count - 1));
    return list;
};
//# sourceMappingURL=geometry.js.map